import { getLocationWithCity } from '@/model'
import nativeHybrid from '@/util/nativeHybrid'

const DEFAULT_CITY = { code: '310100', name: '上海市' }

/** 获取用户定位并转换为城市。定位失败时标记为权限或环境不可用，城市转换失败时使用默认城市。 */
export async function getCurrentCity() {
	try {
		const { latitude, longitude } = await nativeHybrid.getLocation()
		try {
			const { data } = await getLocationWithCity.get({ location: `${longitude},${latitude}` })
			const city = data && data.data
			if (city && city.area_code) {
				return {
					code: city.area_code,
					name: city.name
				}
			}
			throw new Error('未获取到城市')
		} catch (error) {
			console.error('get city error', error)
			return DEFAULT_CITY
		}
	} catch (error) {
		console.error('get location error', error)
		return DEFAULT_CITY
	}
}
